import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from '../menu/menu.service';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  @Input("sub_titulo") sub_titulo: string = "";
  @Input("path") path: string = "";
  @Input("todas_opciones") todas_opciones: boolean = false;
  nombreUsuario: string = "";

  constructor(
    private readonly router: Router,
    private readonly menuService: MenuService,
    private readonly authService: AuthService) {
  }
  ngOnInit(): void {
    this.nombreUsuario = this.authService.getUser().username;
  }

  salirAdministrador() {
    this.menuService.salirAdministrador();
    this.router.navigate(["/login"]);
  }

}
